import PropTypesUtils from '@utils/propTypes'
import Header from '@components/layouts/Header'
import Body from '@components/layouts/Body'
import styles from './Base.module.scss'
import Translate from '@components/atoms/Translate'
import Button from '@components/molecules/Button'
import LightBox from '@components/molecules/LightBox'
import { useEffect, useState } from 'react'

const MIN_WIDTH = 1280

const handleConfirmCloseClick = () => {
  if (!window.onCloseSujetApp) {
    console.warn(
      'No global close function defined. Please create a window.onCloseSujeApp function to be triggered'
    )
    return
  }
  window.onCloseSujetApp()
}

const Base = ({ children }) => {
  const [windowWidth, setWindowWidth] = useState(window.innerWidth)

  useEffect(() => {
    function handleWindowResize() {
      setWindowWidth(window.innerWidth)
    }

    window.addEventListener('resize', handleWindowResize)

    return () => {
      window.removeEventListener('resize', handleWindowResize)
    }
  }, [])

  if (windowWidth < MIN_WIDTH) {
    return (
      <LightBox
        title={<Translate str="global.device.info.title" />}
        body={<Translate str="global.device.info.text" />}
        buttons={
          <div className={styles.closeButtons}>
            <Button bg="dark" onClick={handleConfirmCloseClick}>
              <Translate str="global.device.info.ctaConfirm" />
            </Button>
          </div>
        }
        onClose={handleConfirmCloseClick}
      />
    )
  }

  return (
    <div className={styles.base}>
      <div>
        <Header />
      </div>
      <div className={styles.body}>
        <Body>{children}</Body>
      </div>
    </div>
  )
}

Base.propTypes = {
  children: PropTypesUtils.children.isRequired,
}

export default Base
